import { Controller } from "@hotwired/stimulus"

const SEARCH_DEBOUNCE_MS = 300
const MIN_SEARCH_LENGTH = 2

// Contrôleur léger pour auto-soumettre un formulaire de filtres dans un Turbo Frame.
// Utilise submit() pour les changements instantanés (select, date)
// et submitDebounced() pour la recherche textuelle.
export default class extends Controller {
  connect() {
    this._timeout = null
    this.debouncedSubmit = this.debounce(() => this.element.requestSubmit(), SEARCH_DEBOUNCE_MS)
  }

  disconnect() {
    if (this._timeout) {
      clearTimeout(this._timeout)
      this._timeout = null
    }
  }

  // Soumission immédiate (changement de select, date)
  submit() {
    this.element.requestSubmit()
  }

  // Soumission avec debounce (recherche textuelle)
  submitDebounced(event) {
    const query = event.target.value.trim()
    if (query.length >= MIN_SEARCH_LENGTH || query.length === 0) {
      this.debouncedSubmit()
    }
  }

  debounce(func, wait) {
    return (...args) => {
      clearTimeout(this._timeout)
      this._timeout = setTimeout(() => func(...args), wait)
    }
  }
}
